export default __webpack_public_path__ + "static/media/PIEDRA LUNA.00981773.jpg";